// Early, guarded i18n initialization for @repo/ui.
// Goal: ensure that any module-level usage of i18n.t inside UI components (e.g. Yup schema definitions)
// executes AFTER i18next has at least the base Czech resources loaded, preventing fallback English strings.
// This should NOT override app-specific i18n configuration; if the host app already initialized i18n,
// we skip. Host apps (web, web-old, storybook) can still extend resources / change lng later.

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import cs from "./translations/cs.json";

if (!i18n.isInitialized) {
    // Minimal base init. Do not enable debug here to avoid noisy logs in consumers; apps can reconfigure.
    // Namespace matches existing usage (defaultNS: translations)
    i18n.use(initReactI18next)
        .init({
            resources: {
                cs: { translations: { ...cs } },
            },
            lng: "cs",
            fallbackLng: "cs",
            ns: "translations",
            defaultNS: "translations",
            interpolation: { escapeValue: false },
            // Avoid suspense in library context; host apps can opt-in.
            react: { useSuspense: false },
        })
        .catch(() => {
            /* swallow – host app may initialize later */
        });
}

export {}; // explicit module (no side-effect exports)
